<div class="my-5 flex flex-row justify-center">
  <p-card class="w-full h-[80vh] mx-5">
    <ng-template #header>
      <div class="p-5">
        <strong>Course Player Example</strong>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="p-5 h-[70vh] text-center">
        <div class="p-5 text-2xl w-full h-full">
          @if (viewPrepared()) {
            <iframe [src]="coursePlayerUrl()" class="w-full h-full"></iframe>
          }
        </div>
      </div>
    </ng-template>
  </p-card>
</div>
